import { useState } from "react";
import * as XLSX from "xlsx";

export const useExportar = () => {
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [warning, setWarning] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);
  const resetWarning = () => setWarning(null);

  const exportar = async (
    dados: {
      nomeUsuario: string | null;
      tipoPessoa: string | null;
    }[]
  ) => {
    if (dados.length === 0) {
      setWarning("Nenhuma pessoa foi selecionada para exportar.");
      return;
    }

    try {
      // Criar um worksheet (aba da planilha)
      const worksheet = XLSX.utils.json_to_sheet(dados);

      // Criar um workbook (arquivo Excel)
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Pessoas");

      // Gerar o arquivo e baixar
      XLSX.writeFile(workbook, "Pessoas.xlsx");
      setSuccess("Dados exportados com sucesso!");
    } catch (error) {
      setError("Erro ao exportar os dados. Tente novamente!");
    }
  };

  return {
    exportar,
    error,
    success,
    warning,
    resetError,
    resetSuccess,
    resetWarning,
  };
};
